// extracted by mini-css-extract-plugin
module.exports = {"warning":"count-down_warning__rwjxU","timer":"count-down_timer__2myTa"};